import React from 'react'
import { titleCase } from '../lib/utils'

const DisplaySlugComponent = (props: { value: string | undefined }) => (
  <span>{titleCase(props.value === undefined ? '' : props.value)}</span>
)

export default DisplaySlugComponent
